import React from 'react';

function About() {
    return (
        <React.Fragment>
            <h1>About</h1>
            <p>This is a basic to-do list app.</p>
        </React.Fragment>
    );
}

export default About;